import * as rules from 'vee-validate/dist/rules';

import userApi from '@/api/user';


const customRules = {
  strongPassword: {
    validate (value) {
      if (value.length >= 6) {
        return true;
      }

      return 'Mot de passe trop court';
    }
  },
  uniqueUsername: {
    params: ['id'],
    validate (value, { id }) {
      return userApi.checkUsername(value)
        .then(res => {
          if (!res.entity_id || res.entity_id === id) {
            return true;
          }

          return `Nom d'utilisateur déjà utilisé`;
        })
        .catch(() => {
          return 'Impossible de contacter le serveur';
        });
    }
  }
};

export default function (extend) {
  // loop over VeeValidate rules
  for (let rule in rules) {
    extend(rule, rules[rule]);
  }

  // loop over custom rules
  for (let rule in customRules) {
    extend(rule, customRules[rule]);
  };
};
